import {Router} from "@reach/router";
import {FullPage} from "./common";

export const FullPageRouter = FullPage(Router);
